import { WSLoader } from "@wingspanhq/fe-component-library";
import { useEffect } from "react";
import { GetMissingFieldsLevelParameter } from "@wingspanhq/wingspan-api-sdk";
import { queriesOnboarding } from "@query";
import { useWSAnalytics } from "../../../../utils/WSAnalytics";
import { Documents } from "./Documents";
import { MissingData } from "./MissingData";

type Props = {
  basePath: string;
  onNext?: () => void;
};

export const CollectAdditionalInformation: React.FC<Props> = props => {
  const queryVerificationMissingDataBanking =
    queriesOnboarding.getMissingFields.useQuery(
      { level: GetMissingFieldsLevelParameter.BANKING },
      { refetchOnMount: true }
    );

  const analytics = useWSAnalytics();

  useEffect(() => {
    analytics.track.other("Additional Info Collection Started");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (queryVerificationMissingDataBanking.isFetching) {
    return <WSLoader.Spinner size="S" />;
  }

  if (queryVerificationMissingDataBanking.data?.completeOnboardingToken) {
    return (
      <Documents
        completeOnboardingToken={
          queryVerificationMissingDataBanking.data.completeOnboardingToken
        }
      />
    );
  }

  if (queryVerificationMissingDataBanking.data?.requiredFields?.length) {
    return <MissingData basePath={props.basePath} />;
  }

  return <Finish onNext={props.onNext} />;
};

const Finish: React.FC<{ onNext?: () => void }> = props => {
  const analytics = useWSAnalytics();

  useEffect(() => {
    analytics.track.other("Additional Info Collection Finished");

    props.onNext?.();
  }, [analytics, props, props.onNext]);

  return null;
};
